export default __webpack_public_path__ + "static/media/GD.5af9de13.svg";